"use strict";
var Fp = require('fp/app');

module.exports = class liberte extends Fp {
	constructor() {
		super();
		this.daysShortFormat = ['Di', 'Lu', 'Ma', 'Me', 'Je', 'Ve', 'Sa'];
		this.monthsLibelle = ['Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin', 'Juillet', 'Août', 'Septembre', 'Octobre', 'Novembre', 'Décembre'];
		this.now = new Date();
		this.calendrierSelector = document.getElementById('calendrierLiberte');
		this.periodeSelector = document.getElementById('periodeDepart');
		this.paxSelector = document.getElementById('nbrePersonnes');
		this.btnInscription = document.querySelector('.calendrier__inscription button');
		this.removePickerInit = false;
		this.urlInscription = `/inscription/voyageurs/${config.codeProduct}/`;
		this.classNames = {
			calendrier: {
				'day': 'qs-square',
				'dayDisabled': 'qs-disabled',
				'dayOutsideMonth': 'qs-outside-current-month',
				'dayReturn': 'qs-last-periode',
				'daySelected': 'qs-active',
				'dayAllowed': 'day--allowed',
				'dayNotAllowed': 'day--notallowed',
				'event': 'qs-periode'
			},
			month: {
				'current': 'is-current-month',
				'first': 'is-first-month',
				'last': 'is-last-month'
			},
			day: {
				'current': 'is-current-month',
				'first': 'is-first-day',
				'last': 'is-last-day'
			}
		};
	}

	initialize() {
		/// Function lorsque l'utilisateur change le nombre de pax ou la période
		this.eventChangeNbPaxOrPeriode();

		/// Sur mobile, une seule formule est visible.
		/// Pour afficher les autres, on doit cliquer sur les libellés des autres formules
		helpers.getWindowWidth() < this.breakpoint && this.showFormule();
	}

	/**
	 * eventChangeNbPaxOrPeriode
	 * @description Lorsqu'un event change est intercepté dans la section dates,
	 * si la target correspond aux select du nombre de pax ou de la période, 
	 * on fait un fetch et on recharge le contenu du tableau des prix
	 */
	eventChangeNbPaxOrPeriode() {
		let self = this;

		document.getElementById('sectionDates').addEventListener('change', function (e) {
			const {
				target
			} = e;
			let obj = {
				nb: self.paxSelector.value,
				periode: self.periodeSelector.value
			}
			if (target.id === 'nbrePersonnes' || target.id === 'periodeDepart') {
				self.loadDatePrix(obj)
			}
		})
	}

	/**
	 * ShowFormule
	 * @description Affichage des formules sur mobile
	 */
	showFormule() {
		let self = this,
			btns = document.querySelectorAll('[data-formule-liberte]');
		btns.forEach((el) => {
			el.addEventListener('click', function (e) {
				let formules = document.querySelectorAll('.liberte__liste');

				let idFormule = this.dataset.formuleLiberte;
				btns.forEach(btn => btn.classList.add(self.selectors.inactiveClass));
				this.classList.remove(self.selectors.inactiveClass);
				formules.forEach(formule => (formule.dataset.formuleId === idFormule) ? formule.classList.remove(self.selectors.hiddenClass) : formule.classList.add(self.selectors.hiddenClass))
			})
		});
	}

	/**
	 * loadDateProx
	 * @description on reload le tableau des prix indiv lorsque le nombre de pax ou la période change
	 * @param {object} obj nb et periode sont deux propriétés d'obj correspondant 
	 * respectivement au nombre de pax et à la période choisie
	 */
	loadDatePrix(obj) {
		let self = this,
			nb = obj.nb,
			periode = obj.periode;

		const url = `${config.urlMajDatePrix}?codeProduit=${config.codeProduct}&nbPersonne=${nb}&period=${periode}`;
		const html = super.getPromiseHtml(url);
		html.then((data) => {
			document.getElementById('liberteDates').innerHTML = data;
		}).then(() => {
			document.getElementById('liberteDates').querySelectorAll('[data-url]').forEach(el => el.addEventListener('click', function(e) {
				window.location.href = e.target.dataset.url
			}))
			if (helpers.getWindowWidth() < this.breakpoint) {
				let activeFormule = document.querySelector(`[data-formule-liberte]:not(.${self.selectors.inactiveClass})`).dataset.formuleLiberte;
				let formules = document.querySelectorAll('.liberte__liste');
				formules.forEach(formule => (formule.dataset.formuleId === activeFormule) ? formule.classList.remove(self.selectores.hiddenClass) : formule.classList.add(self.selectores.hiddenClass));
			}
		});
	}

	/*
	 *
	 *	⇓⇓ Popin Calendrier méthodes ⇓⇓
	 *
	 */
	launchDatepicker(el) {
		/// On récupère la plage de date possible
		let periode = [];
		/// Dans le cas où l'on n'a qu'une période
		if (this.periodeSelector.type === 'hidden') {
			periode = this.periodeSelector.dataset.periode.split(',')
		} else {
			periode = this.periodeSelector.options[this.periodeSelector.selectedIndex].dataset.periode.split(',');
		}

		let settingsLiberte = {
			'duree': config.duree,
			'urlInscription': this.urlInscription,
			'dateDebutPeriode': new Date(periode[0]),
			'dateFinPeriode': new Date(periode[1]),
			'jourDepartPossible': el.dataset.jourPossible
		}

		this.setPrice(el.dataset.prix, 'prixParPersonne');
		this.setFormule(el.dataset.formule);
		this.calendrier(settingsLiberte)
	}

	calendrier(options) {
		let self = this,
			picker = {},
			dateMin = options.dateDebutPeriode >= self.now ? options.dateDebutPeriode : self.getBornesPeriode(self.now, 1); // On calcule les dates d'affichage les plus anciennes possibles selon la date du jour et celle du début de période de départ

		let optionsCalendrier = {
			alwaysShow: true,
			customDays: this.daysShortFormat,
			customMonths: this.monthsLibelle,
			disableYearOverlay: true,
			maxDate: options.dateFinPeriode,
			minDate: dateMin,
			showAllDates: true,
			startDate: dateMin,
			startDay: 1,
			events: [
				dateMin,
				options.dateFinPeriode
			],
			onMonthChange: instance => {

				/// set les 1er et dernier jour du mois
				let daysOfMonth = document.querySelectorAll('[data-direction="0"]');
				daysOfMonth[0].classList.add(self.classNames.day.first);
				daysOfMonth[daysOfMonth.length - 1].classList.add(self.classNames.day.last);

				// Gérer l'état du mois courant :
				// === mois d'aujourd'hui || === mois du début/fin de la période de départ
				self.testIfPrevMonthIsPast(instance, options);

				/// On navigue de mois en mois avec une date sélectionnée
				if (instance.dateSelected != undefined) {
					/// Le mois de la date sélectionnée correspond au mois en cours
					/// on ajoute une classe qs-event depuis la date sélectionné jusqu'au dernier jour du mois, on stoppe au nombre de jours du voyage
					if (instance.dateSelected.getMonth() === instance.currentMonth) {
						self.putSelectedPeriode(`.${self.classNames.calendrier.daySelected}`, `.${self.classNames.calendrier.dayOutsideMonth}`, options.duree);
					} else if (parseInt(window.sessionStorage.getItem('selectedDaysNextMonth')) > 0) {
						/// Si le mois affiché est le M+1 du mois de la date sélectionnée ou si mois affiché est janvier et mois de la daté sélectionnée est décembre
						if (instance.currentMonth - instance.dateSelected.getMonth() === 1 || instance.dateSelected.getMonth() - instance.currentMonth === 11) {
							self.putSelectedPeriode(`.${self.classNames.day.first}`, '[data-direction="1"]', parseInt(window.sessionStorage.getItem('selectedDaysNextMonth')));
						}
					}
				}
				// On relance la function pour les jours de départ autorisés
				options.jourDepartPossible != 'all' && self.calcDays(options);

			},
			onShow: instance => {

				self.testIfPrevMonthIsPast(instance, options);

				picker.minDate = window.sessionStorage.getItem('dateDebutPeriode') === null ? options.dateDebutPeriode : window.sessionStorage.getItem('dateDebutPeriode');
				picker.maxDate = window.sessionStorage.getItem('dateFinPeriode') === null ? options.dateFinPeriode : window.sessionStorage.getItem('dateFinPeriode');

				// À l'affichage, le mois courant est le dernier mois de la période de départ
				if (options.dateFinPeriode.getMonth() === instance.currentMonth) {
					let datePickerElement = document.querySelector('.datepicker');
					datePickerElement.classList.add(self.classNames.month.last);
				}
			},
			// Au click sur une date
			onSelect: (instance, date) => {

				// On stocke la date selectionnée en session
				window.sessionStorage.setItem('dateSelected', instance.dateSelected);
				// On vide la valeur 
				window.sessionStorage.setItem('selectedDaysNextMonth', '');

				/// Au select d'une date, on supprime la période sélectionnée
				let selectorDay = document.querySelectorAll(`.${self.classNames.calendrier.day}`);
				for (var i = 0; i < selectorDay.length; i++) {
					selectorDay[i].classList.remove(self.classNames.calendrier.event);
					selectorDay[i].classList.remove(self.classNames.calendrier.dayReturn);
					selectorDay[i].classList.remove('daySelectedNotFirstDayPeriode');
				}

				/// On pousse la période
				self.putSelectedPeriode(`.${self.classNames.calendrier.daySelected}`, `.${self.classNames.calendrier.dayOutsideMonth}`, options.duree);
				/// Si une partie de la période du voyage se situe hors période de départ
				if (window.sessionStorage.getItem('selectedDaysNextMonth') > 0) {
					self.putSelectedPeriode(`.${self.classNames.calendrier.daySelected}`, `.${self.classNames.calendrier.dayOutsideMonth}`, options.duree);
				}

				// On active le btn d'inscription
				self.btnInscription.removeAttribute('disabled');

				// On calcule l'url d'inscription
				let newPathDateInscription = '';
				if (instance.dateSelected !== undefined) {
					let dateSelected = new Intl.DateTimeFormat('fr-FR').format(instance.dateSelected),
						formattedDate = dateSelected.replaceAll('/', '-');

					newPathDateInscription = `${formattedDate}${window.sessionStorage.getItem('formule')}`;
				} else {
					// On desactive le btn d'inscription
					self.btnInscription.setAttribute('disabled', '');
				}

				// Au click sur le bouton inscription, on est redirigé vers le tunnel
				self.btnInscription.addEventListener('click', function (e) {
					window.location.href = options.urlInscription + newPathDateInscription;
				});

				self.testIfPrevMonthIsPast(instance, options);
			}
		}

		picker = datepicker(self.calendrierSelector, optionsCalendrier);

		this.putClassOfMonth(options);
	}

	/// Une fois le calendrier initialisé, on ajoute des classes à différents jours pour le style
	putClassOfMonth(options) {

		let days = document.querySelectorAll('.qs-square:not(.qs-disabled):not(.qs-day)');
		if (days === null) throw 'Days est null';
		days[days.length - 1].classList.add(this.classNames.day.last);

		// On ajoute une classe au dernier jour du mois
		let daysOfNextMonth = document.querySelectorAll('[data-direction="1"]');
		daysOfNextMonth != null && daysOfNextMonth.length > 0 && daysOfNextMonth[0].previousSibling.classList.add(this.classNames.day.last);

		// On ajoute une classe au dernier jour de la période
		if (window.sessionStorage.getItem('dateSelected') != null) {
			if (document.querySelector(`.qs-event + .${this.classNames.calendrier.dayDisabled}`) != null) {
				let lastDayOfPeriode = document.querySelector(`.qs-event + .${this.classNames.calendrier.dayDisabled}`).previousSibling;
				lastDayOfPeriode.classList.add(this.classNames.day.last);
			}
		}

		options.jourDepartPossible != 'all' && self.calcDays(options);
	}
	/**
	 * testIfPrevMonthIsPast
	 * @description  Function permettant de gérer la relation entre le mois du calendrier affiché et le mois actuel, ceux du début et de fin de période
	 * 	Elle ajoute une class au datepicker pour desactiver la navigation hors période / (mois + année calendrier < NOW && mois + année calendrier < début période) 	/ (mois + année calendrier > fin de période (+ durée voyage hors période de départ))
	 */
	testIfPrevMonthIsPast(obj, options) {

		let datePickerElement = document.querySelector('.datepicker'),
			monthClass = this.classNames.month;

		/// Est-ce que l'on est le mois en cours ?
		if (obj.currentMonth === this.now.getMonth() && obj.currentYear === this.now.getFullYear()) {
			datePickerElement.classList.add(monthClass.current);
		} else {
			datePickerElement.classList.remove(monthClass.current);
		}

		/// Est-ce que le mois en cours est le 1er de la période ? 
		if (obj.currentMonth === options.dateDebutPeriode.getMonth() && obj.currentYear === options.dateDebutPeriode.getFullYear()) {
			datePickerElement.classList.add(monthClass.first);
		} else {
			datePickerElement.classList.remove(monthClass.first);
		}

		/// On retire la class is-last-month
		datePickerElement.classList.remove(monthClass.last);

		if (obj.dateSelected === undefined) {
			if (obj.currentMonth === options.dateFinPeriode.getMonth() && obj.currentYear === options.dateFinPeriode.getFullYear()) {
				datePickerElement.classList.add(monthClass.last);
			} else {
				datePickerElement.classList.remove(monthClass.last);
			}
		} else {
			let moisFinPeriode = options.dateFinPeriode.getMonth(),
				anneeFinPeriode = options.dateFinPeriode.getFullYear(),
				dateRetour = this.getBornesPeriode(obj.dateSelected, options.duree - 1),
				dateCourante = new Date(obj.currentYear, obj.currentMonth);

			this.isLastMonth(dateRetour, dateCourante, anneeFinPeriode, moisFinPeriode) ? datePickerElement.classList.add(monthClass.last) : datePickerElement.classList.remove(monthClass.last);
		}
	}

	/**
	 * SET PRICE
	 * @description On ajoute le prix par personne à l'ouverture de la modal
	 * @param {string} prix
	 * @param {string} id
	 */
	setPrice(prix, id) {
		document.getElementById(id).innerHTML = prix;
	}
	/**
	 * SET FORMULE
	 * @description On stocke {formule} en session pour la concatener 
	 * avec l'url d'inscription lors du click sur le bouton s'inscrire
	 * @param {string} formule
	 */
	setFormule(formule) {
		window.sessionStorage.setItem('formule', formule);
	}
	/**
	 * getBornesPeriode
	 * @description On renvoie une date à laquelle on a ajouté ou retiré n jours
	 * @param {date} date
	 * @param {int} days
	 */
	getBornesPeriode(date, days) {
		const copy = new Date(Number(date));
		copy.setDate(date.getDate() + days);
		return copy;
	}
	/**
	 * calcDays
	 * @description Seuls certains jours de départs sont possibles
	 */
	calcDays(options) {
		let arrayJourPossible = options.jourDepartPossible.split(','),
			daysDisabled = this.daysShortFormat;
		// On ajoute une classe aux jours de départ possible
		// et on calcul l'array des jours non disponibles
		for (var i = 0; i < arrayJourPossible.length; i++) {
			document.querySelectorAll(`.qs-num.${optionsCalendrier.customDays[arrayJourPossible[i]]}`).forEach(elem => elem.classList.add(this.classNames.calendrier.dayAllowed));

			let index = daysDisabled.indexOf(optionsCalendrier.customDays[arrayJourPossible[i]]);
			daysDisabled.splice(index, 1);
		}

		for (var i = 0; i < daysDisabled.length; i++) {
			document.querySelectorAll(`.qs-num.${daysDisabled[i]}`).forEach(elem => elem.classList.add(this.classNames.calendrier.dayNotAllowed));
		}
	}
	/**
	 * putSelectedPeriode
	 * @description On met en valeur la période sélectionnée
	 */
	putSelectedPeriode(elem, selector, duree) {

		// Initialisation de l'array qui va être populé 
		// par les dates incluses dans la période
		var siblings = [];

		// On prend le jour suivant la date séléctionnée
		elem = document.querySelector(elem);

		// On popule l'array via une boucle
		while (elem) {

			// Si l'on atteint un jour hors du mois courant
			if (elem.matches(selector)) break;

			// On stoppe l'array lorsque sa longueur atteint le nombre de jour du voyage
			if (siblings.length === duree) break;

			// On popule l'array
			siblings.push(elem);

			// On incrémente avec l'élément suivant
			elem = elem.nextElementSibling;
		}

		// Une fois le tableau rempli,
		// on ajoute une classe aux dates de la période sélectionnée
		for (var i = 0; i < siblings.length; i++) {
			siblings[i].classList.add(this.classNames.calendrier.event);
			if (i + 1 === siblings.length) {
				siblings[i].classList.add(this.classNames.calendrier.dayReturn);
			}
		}

		// Le mois courant est celui de la date de départ
		let dayOfTravel = document.querySelector(`.${this.classNames.calendrier.daySelected}`);
		if (dayOfTravel != null) {

			let dayBeforeStart = document.querySelector(`.${this.classNames.calendrier.daySelected}`).previousSibling;

			// Le jour de départ n'est pas le 1er jour de la période de départ
			if (!dayBeforeStart.classList.contains(this.classNames.calendrier.dayDisabled)) {
				siblings[0].classList.add('daySelectedNotFirstDayPeriode');
			}
		}

		// Au cas où une partie de la période serait à cheval sur le mois suivant
		if (siblings.length < duree) {
			let selectedDaysNextMonth = duree - siblings.length;
			window.sessionStorage.setItem('selectedDaysNextMonth', selectedDaysNextMonth);
		}
	}

	/**
	 * @description Méthode retournant un bool indiquant 
	 * si le calendrier affiche ou non le dernier mois possible de la période de départ
	 */

	isLastMonth(dateRetour, dateCourante, anneeFinPeriode, moisFinPeriode) {
		let isLastMonth = false;
		if (dateRetour < dateCourante) {
			if (dateCourante.getFullYear() < anneeFinPeriode || dateCourante.getMonth() < moisFinPeriode) {
				isLastMonth = false;
			} else {
				isLastMonth = true;
			}
		} else if (dateRetour.getMonth() === dateCourante.getMonth() && dateRetour.getFullYear() === dateCourante.getFullYear()) {
			/// La fin de période est l'année N+1
			if (dateCourante.getFullYear() < anneeFinPeriode) {
				isLastMonth = false;
			} else if (dateCourante.getFullYear() === anneeFinPeriode) {
				if (dateCourante.getMonth() < moisFinPeriode) {
					isLastMonth = false;
				} else {
					isLastMonth = true;
				}
			} else {
				if (dateCourante.getFullYear() > anneeFinPeriode) {
					isLastMonth = true;
				}
			}
		} else if (dateRetour.getMonth() > dateCourante.getMonth() && dateRetour.getFullYear() >= dateCourante.getFullYear()) {
			isLastMonth = false;
		} else {
			if (anneeFinPeriode >= dateCourante.getFullYear()) {
				isLastMonth = false;
			} else {
				isLastMonth = true;
			}
		}
		return isLastMonth;
	}
}